module.exports = __webpack_public_path__ + "img/tema-1-3.bcc6c4dd.png";